import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, useSlots } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderToggler',
  setup(__props) {

const slots = useSlots()

const scrollPosition = ref(0)
const state = ref({
  sidebar: false,
  userBar: false,
})

const toggle = (key: string) => {
  state.value[key] = !state.value[key]

  if (state.value[key]) {
    scrollPosition.value = window.pageYOffset

    addStyles()
  } else {
    removeStyles()
  }
}

const open = (key: string) => {
  state.value[key] = true

  scrollPosition.value = window.pageYOffset

  addStyles()
}

const hide = (key: string) => {
  state.value[key] = false

  removeStyles()
}

const addStyles = () => {
  const bodyEl = document.querySelector('body') as HTMLElement
  const htmlEl = document.querySelector('html') as HTMLElement

  bodyEl.classList.add('is-overflow')

  bodyEl.style.position = 'fixed'
  bodyEl.style.top = `-${scrollPosition.value}px`
  bodyEl.style.width = '100%'

  bodyEl.classList.add('disable-smooth')
  htmlEl.classList.add('disable-smooth')
}

const removeStyles = () => {
  const bodyEl = document.querySelector('body') as HTMLElement
  const htmlEl = document.querySelector('html') as HTMLElement

  bodyEl.classList.remove('is-overflow')

  bodyEl.style.removeProperty('position')
  bodyEl.style.removeProperty('top')
  bodyEl.style.removeProperty('width')

  window.scrollTo(0, scrollPosition.value)

  bodyEl.classList.remove('disable-smooth')
  htmlEl.classList.remove('disable-smooth')
}

const render = () => slots.default({
  sidebarIsActive: state.value.sidebar,
  userBarIsActive: state.value.userBar,
  toggle,
  hide,
  open,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})